// extracted by mini-css-extract-plugin
module.exports = {"btn":"PageButton-module--btn--18x0-"};